import getDomain from './getDomain';
import sameDomain from './sameDomain';

export default (url, isThatDomain, replaceToDomain) => {
  if (isThatDomain && replaceToDomain) {
    if (sameDomain(window.location.href, isThatDomain)) {
      return url.replace(getDomain(url), getDomain(replaceToDomain));
    }
  }

  return url;
};
